import Base from '../../../src/js/classes/Base'
import Cookies from 'js-cookie'

export default class NewsletterPopup extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				close: '.e-NewsletterPopup__container__close button',
				bg: '.e-NewsletterPopup__bg',
			},
			options: {},
			classes: {
				newsletterOpen: 'newsletter-open',
			},
			state: {},
		})
		this.boundOnClose = this.onClose.bind(this)
		this.boundStopPropagation = (e) => e.stopPropagation()
		this.resize()
		this.addEvents()
		this.show()
	}

	addEvents() {
		this.elements.close.addEventListener('click', this.boundOnClose)
		this.elements.bg.addEventListener('click', this.boundOnClose)
		this.element.addEventListener('click', this.boundStopPropagation)
	}

	removeEvents() {
		this.elements.close.removeEventListener('click', this.boundOnClose)
		this.elements.bg.removeEventListener('click', this.boundOnClose)
		this.element.removeEventListener('click', this.boundStopPropagation)
	}

	resize() {}

	update() {}

	unmount() {
		window.clearInterval(this.interval)
		this.removeEvents()
		document.body.classList.remove(this.classes.newsletterOpen)
	}

	show() {
		this.interval = window.setInterval(() => {
			if (document.body.classList.contains('home') && !document.body.classList.contains('preloaded')) {
				return
			}
			if (!Cookies.get('hide-newsletter-popup')) {
				document.body.classList.add(this.classes.newsletterOpen)
				window.clearInterval(this.interval)
			}
		}, this.settings.newsletterPopupDelayMs)
	}

	onClose(e) {
		if (e) {
			e.preventDefault()
			e.stopPropagation()
		}
		window.clearInterval(this.interval)
		Cookies.set('hide-newsletter-popup', 1, { expires: this.settings.newsletterPopupExpiryDays })
		document.body.classList.remove(this.classes.newsletterOpen)
	}
}
